// extracted by mini-css-extract-plugin
export default {"mapContainer":"EmbeddedMap_mapContainer__VhdpK"};